import React, {Component} from 'react'
import PropTypes from 'prop-types'
import OpenSeaDragon from './containers/OpenSeaDragon.js'

class Background extends Component {
  render () {
    const {
      className,
      minZoomLevel,
      maxZoomLevel,
      defaultZoomLevel
    } = this.props

    return (
      <div className={className || 'map'}>
        <OpenSeaDragon
          className='openseadragon'
          minZoomLevel={minZoomLevel}
          maxZoomLevel={maxZoomLevel}
          defaultZoomLevel={defaultZoomLevel}
        />
      </div>
    )
  }
}

Background.propTypes = {
  className: PropTypes.string,
  minZoomLevel: PropTypes.number,
  maxZoomLevel: PropTypes.number,
  defaultZoomLevel: PropTypes.number
}

export default Background
